import React, { useState, useEffect, useRef,useContext } from "react";
import {
  Modal,
  ContextualMenu,
  mergeStyleSets,
  IconButton,
  TextField,
  Spinner,
  SpinnerSize,
  SearchBox,
} from "@fluentui/react";
import { getClientProviders } from "../../service/StudyListService";
import themeContext from "../../context/theme/ThemeContext";
import studylistContext from "../../context/studylist/StudylistContext";
import userContext from "../../context/users/UserContext";
import { BORDER, MODAL_TYPE, USERTYPES } from "../../constants/Constants";
import { t } from "i18next";
import loaderContext from "../../context/loader/LoaderContext";

const CustomDropDownList = (props) => {

  const {theme, themeName, setThemeName, setTheme} = useContext(themeContext);
  const { roles } = useContext(userContext);
  const { showModal, setShowModal} = useContext(loaderContext);
  const { handleUpdateDataQueryStateProviderList,providerDdlList,setProviderDdlList } = useContext(studylistContext);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterValue, setFilter] = useState('');

  const [clientProvidersList, setClientProvidersList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  let enterprise =
    process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" ||
    process.env.REACT_APP_ENTERPRISE_PLATFORM == true
      ? true
      : false;

  const data = props.data.row.original;


  const generateClientProviders = async () => {
    let radiologistList = [];
    const clientProvidersMapping = {
      clientId:
        props.data.row.original.assignmentList[props.assignmentNumber].clientId,
      firmId:
        props.data.row.original.assignmentList[props.assignmentNumber].firmId,
      studyId:
        props.data.row.original.id  
    };
    try{setLoading(true);
    const response = await getClientProviders(clientProvidersMapping);
    console.log(response);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      if (
        (response.data.data.radiologists != null ||
          response.data.data.radiologists != undefined) &&
        response.data.data.radiologists.length > 0
      ) {
        response.data.data.radiologists.map((radiologist) => {
          let providerRadName =
            radiologist.firstName + " " + radiologist.lastName;
          let onPayroll =
            !enterprise && radiologist.onPayroll === true ? " *" : " ";
          radiologistList.push({
            key: "R" + radiologist.id,
            text: providerRadName + onPayroll,
            activeStatus: radiologist.activeStatus,
          });
        });
      }
      if (props.data.row.original.reportDoneStatus != 2) {
        if (
          (response.data.data.providers != null ||
            response.data.data.providers != undefined) &&
          response.data.data.providers.length > 0
        ) {
          response.data.data.providers.map((provider) => {
            radiologistList.push({
              key: "F" + provider.id,
              text: provider.name,
              disabled: (props.data.row.original.xrayVersion === true && provider.cxrVersion === 0) || (props.data.row.original.xrayVersion === false && (provider.cxrVersion === 1 || provider.cxrVersion === 2)) 
            });
          });
        }
      }
      if (radiologistList.length == 0) {
        radiologistList.push({
          key: "0",
          text: !enterprise
            ? "Providers not found."
            : "Radiologists not found.",
        });
      }
      setLoading(false);
      // handleUpdateDataQueryStateProviderList(radiologistList, data.id)
      setClientProvidersList(radiologistList);
      setOriginalList(radiologistList);
    }else{
      setLoading(false);
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
    }catch(e){
      setLoading(false);
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    // if(providerDdlList.hasOwnProperty(data.id) && roles[0] != USERTYPES.ADMIN){
    //   setLoading(false)
    //   setClientProvidersList(providerDdlList[data.id]);
    //   setOriginalList(providerDdlList[data.id]);
    // }else{
     generateClientProviders();
    // }
    
  }, []);

  const ref = useRef(null);
  const { onClickOutside } = props;

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const handleFilterChange = (event,data) => {
    if(data != null && data != undefined)data = data.trim();
    const inputValue = data;
    setFilter(inputValue);
  
    // Filter the original list based on the filter value
    const filteredResults = originalList.filter((item) =>
      item.text.toLowerCase().includes(inputValue.toLowerCase())
    );
  
    // Set the filtered results to the state
    setClientProvidersList(filteredResults);
  };

  const clearFilter = () => {
    setFilter('');
    setClientProvidersList(originalList);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(()=>{
      if(ref.current != undefined && ref.current != null && props.childRef != null && props.childRef != undefined){
        props.childRef(ref);
      }
  },[ref])

  if (!props.show) return null;

  const customSpinnerStyle = {
    root:{
      height:"100px"
    },
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const getRadiologistStatusColor = (status) => {
    if (status == 0) {
      return "gray";
    } else if (status == 1) {
      return "red";
    } else if (status == 2) {
      return "green";
    }
  };

  const searchIcon = {
    iconName: "search",
    cursor: "pointer",
    style: { color: "rgba(172, 172, 172, 0.75)"},
  };

  const searchInputStyle = {
    root: {
      width: "148px",
     
    },
    field: {
      borderRadius: "7px",
    },
  };

  return (
    <div
      className="custom-dropdown-list"
      style={{
        
        maxHeight: clientProvidersList.length > 3 ? "160px" : "unset",
        height: loading ? "160px" : "unset",
      }}
      ref={ref}
    >
      <div className="custom-dropdown-search-box">
      {!loading && <TextField
                label=""
                placeholder="Search..."
                styles={searchInputStyle}
                value={filterValue}
                onClick={(ev)=>{ev.stopPropagation();console.log(ev)}}
                onChange={(ev,value) => {ev.stopPropagation();handleFilterChange(ev,value)}}
                iconProps={searchIcon}
                autoFocus={true}
              />}
      </div>
      <div 
      style={{
        alignItems:
          !loading && clientProvidersList.length != 0 ? "flex-start" : "center",
      }}
      className="custom-drodown-list-container assign-dropdown-modal-scroll-light">
      {loading ? (
        <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      ) : clientProvidersList.length > 0 ? <>
        {clientProvidersList.map((ele, index) => {
          return (
            ele.key[0] == "R" &&<div
              onClick={() => {
                props.handleOnSelect(ele.text, ele.key);
              }}
              key={index}
              className="custom-dropdown-list-item"
            >
              {ele.key[0] == "R" && (
                <div
                  className="active-circle"
                  style={{
                    background: getRadiologistStatusColor(ele.activeStatus),
                  }}
                ></div>
              )}
              {ele.key[0] == "R" && <span style={{width:"125px",wordWrap:"break-word"}}>{ele.text}</span>}
            </div>
          );
        })
        }
      <div style={{width:"100%",height:"2px", borderTop: BORDER.TAB}}></div>
      {clientProvidersList.map((ele, index) => {
          return (
            ele.key[0] !== "R" && <div
              onClick={() => {
                if(ele.disabled) {
                  return;
                }
                props.handleOnSelect(ele.text, ele.key);
              }}
              key={index}
              className={`custom-dropdown-list-item ${ele.disabled ? "custom-dropdown-list-item-disabled" : ""}`}
            >
              {ele.text}
            </div>
          );
        })
        }
        </>
       : (
        <div className="custom-dropdown-list-item">
          No record found
        </div>
      )}
      </div>
    </div>
  );
};

export default CustomDropDownList;
